<div>
  <div class="gb-dialog-header">
    <h1>
      {{ 'USERS.EDIT_USER.TITLE' | translate }}
    </h1>

    <button mat-icon-button (click)="closeDialog()">
      <gb-icon icon="close"></gb-icon>
    </button>
  </div>

  <div class="gb-dialog-content">
    <p translate="USERS.EDIT_USER.SUBTITLE"></p>
    <div class="user-invite">
      @if (inviteEmail$ | async; as inviteEmail) {
        <p>
          <span translate="USERS.EDIT_USER.INVITE_EMAIL_LABEL"></span>
          <span> {{ inviteEmail }} </span>
        </p>
      }
      @if (invitePhoneNumber$ | async; as invitePhoneNumber) {
        <p>
          <span translate="USERS.EDIT_USER.INVITE_PHONE_LABEL"></span>
          <span> {{ invitePhoneNumber }} </span>
        </p>
      }
    </div>
    @if (showChangePasswordButton$ | async) {
      @if ({ selectedUserUser: selectedUserUser$ | async, selectedUserUuid: selectedUserUuid$ | async }; as obs) {
        <button
          mat-stroked-button
          translate="USERS.EDIT_USER.CHANGE_PASSWORD"
          (click)="openChangePasswordDialog(obs.selectedUserUser!, obs.selectedUserUuid!)"
          class="change-password-button"
        ></button>
      }
    }
    <form [formGroup]="editUserForm">
      <gb-form-field [control]="first_name" labelTranslateKey="USERS.EDIT_USER.FIRST_NAME"></gb-form-field>
      <gb-form-field [control]="last_name" labelTranslateKey="USERS.EDIT_USER.LAST_NAME"></gb-form-field>
      @if (showPaddleNumber$ | async) {
        <gb-paddle-number-input [control]="paddle_number" [profile]="selectedUser$ | async"> </gb-paddle-number-input>
      }
      <mat-checkbox [formControl]="display_anonymous">{{ 'USERS.EDIT_USER.MAKE_ANONYMOUS' | translate }}</mat-checkbox>

      @if (showPhoneNumberField$ | async) {
        <mat-form-field>
          <mat-label translate="PHONE_INPUT_LABEL"> </mat-label>
          <gb-intl-phone-input
            formControlName="phone_number"
            name="phone_number"
            [auctionCountryCode]="(auction$ | async)?.country"
          ></gb-intl-phone-input>
        </mat-form-field>
      }
      <!--@if (showPreferredContactSelect$ | async) {
      <gb-preferred-contact-select
        [control]="preferred_contact"
        [phoneVerified]="phoneVerified$ | async"
        [emailVerified]="emailVerified$ | async"
        (resendEmailVerification)="resendEmailVerification()"
        (resendPhoneVerification)="resendPhoneVerification()"
      ></gb-preferred-contact-select>
      }-->
    </form>

    @if (showInviteCodes$ | async) {
      <gb-staff-only-options class="invite-codes">
        @if (smsInviteCode$ | async; as smsInviteCode) {
          <p>
            <span translate="USERS.EDIT_USER.SMS_INVITE_CODE"></span>
            <span> {{ smsInviteCode }} </span>
          </p>
        }
        @if (emailInviteCode$ | async; as emailInviteCode) {
          <p>
            <span translate="USERS.EDIT_USER.EMAIL_INVITE_CODE"></span>
            <span> {{ emailInviteCode }} </span>
          </p>
        }
      </gb-staff-only-options>
    }
  </div>

  <div class="gb-flex-button-container gb-dialog-actions-container">
    @if ((selectedUser$ | async)?.invite_state !== InviteStateEnum.Complete) {
      <button (click)="submitForm(true)" mat-stroked-button [disabled]="(saveAndSendInviteLoaded$ | async) === false">
        <gb-button-loader [loaded$]="saveAndSendInviteLoaded$" [usePrimaryColor]="true">
          <span> {{ 'USERS.CREATE_USER.SAVE_AND_SEND_INVITE' | translate }}</span>
        </gb-button-loader>
      </button>
    }
    <button (click)="submitForm()" mat-flat-button [disabled]="(editCreateLoaded$ | async) === false">
      <gb-button-loader [loaded$]="editCreateLoaded$">
        <span> {{ 'SAVE' | translate }}</span>
      </gb-button-loader>
    </button>
  </div>
</div>
